import styled from 'styled-components';

type Props = {
  backgroundColor: string;
  maxWidth?: string;
};

export const TestTypeBackgroundStyled = styled.div<Props>`
  height: 20px;
  max-width: ${(props) => props.maxWidth || 'auto'};
  background-color: ${(props) => props.backgroundColor};
  padding: 0 4px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TestTypeNameStyled = styled.div<{ textColor: string }>`
  color: ${(props) => props.textColor};
  padding-left: 2px;
  padding-right: 2px;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
